
import Header from '../components/header';
import Footer from '../components/footer';
// import Filtersearch from '../components/filtersearch';
import { GitFork, Star, ExternalLink} from 'lucide-react';
import {Search, ChevronDown} from 'lucide-react';
import { useEffect, useState, useRef, useCallback } from 'react';
// import { dataSet } from '../data/data';

function Projects() {
    const LanguagesData = ["All", "Javascript", "Reactjs", "Python", "Dart", "Jupiter Notebook", "Swift", "Typescript", "PHP", "Flutter", "C++", "C#"];
    // const levelsData = ["All", "Beginner", "Intermediate", "Advanced"];
    const [projectTitle, setProjectTitle] = useState("");
    const [languageSearch, setLanguageSearch] = useState("All")
    // const [levelsSearch, setLevelsSearch] = useState("All")
    // const [filteredSearch, setFilteredSearch] = useState(dataSet);
    // const [displayLevels, setDisplayLevels] = useState(false);
    const [displayLanguage, setDisplayLanguage] = useState(false);
    const toggleRef = useRef(null);
    const [page, setPage] = useState(1);
    const [repos, setRepos] = useState([]);
    const [hasmore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const PER_PAGE = 10;
    //  fetching api data
    const fetchRepos = useCallback(async (pageNumber, searchTerm, language) => {
        setLoading(true);
        try{

            const token = process.env.REACT_APP_GITHUB_TOKEN;
            const gitlink = process.env.REACT_APP_GITHUB_API;

            const lastYear = new Date();
            lastYear.setFullYear(lastYear.getFullYear() - 1);
            const pushedSince = lastYear.toISOString().split('T')[0];
            
            let query = `is:public+topic:opensource+pushed:>=${pushedSince}`;
            if (searchTerm) query += `+${searchTerm} in:name,description`;
            if (language && language !== "All") query += `+language:${language}`; 

            const result = await fetch(`${gitlink}?q=${query}&sort=stars&order=desc&per_page=${PER_PAGE}&page=${pageNumber}`, {
                headers: {
                    Accept: 'application/vnd.github.mercy-preview+json',
                    ...(token && {Authorization : `Bearer ${token}`} )
                }
            })

            const data = await result.json();

            if(!data.items || data.items.length === 0 ){
                setHasMore(false);
                return;
            }

            console.log(data.items)

            setRepos((prev) => {
                const updated = [...prev, ...data.items];
                return updated
            })
            console.log(data.items);
            console.log(data);
        }catch(error){
            console.log(error)
        }finally{
            setLoading(false)
        }
    }, []);

    const handleSearch = (e) => {
        e.preventDefault();
        setRepos([]);
        setHasMore(true);
        setPage(1);
        // fetchRepos(page, projectTitle, languageSearch)
       
    }


    useEffect(() => {
        fetchRepos(page, projectTitle, languageSearch)
    }, [page, projectTitle, languageSearch, fetchRepos]);

    useEffect(() => {
        const closeToggleOutside = (event) => {
            if( toggleRef.current && !toggleRef.current.contains(event.target)){
                setDisplayLanguage(false);
            }
        }

        document.addEventListener('mousedown', closeToggleOutside);

        return () => {
            document.removeEventListener('mousedown', closeToggleOutside);
        }
    }, [])

  
  return (
    <div className="min-h-screen w-full bg-[#f8fafc] border border-black">
        
        <Header className="bg-[#f5f5fd]"/>

        {/* hero section */}

        {/* <Filtersearch /> */}
        <form onSubmit={handleSearch} className="relative flex flex-col md:flex-row justify-col gap-4 py-5 px-10 md:px-30 bg-white">
            
            <div className='relative w-full md:w-[70%] hover:shadow-md transition ease-in-out'>
                <Search size={18} className='absolute left-3 top-1/2 -translate-y-1/2 text-gray-400'/>
                <input type='text' 
                placeholder='Search Projects' 
                className='bg-[#f8fafc] py-3 px-5  pl-11 border w-full h-10 rounded-md text-base border border-gray-300'
                value={projectTitle}
                onChange={(e)=> setProjectTitle(e.target.value)}
                />
            </div>
            
            <div ref={toggleRef} className='relative bg-[#f8fafc] border h-10 w-full md:w-[20%] rounded-md py-3  text-base border border-gray-300 flex items-center hover:shadow-md transition ease-in-out'>
                <div className='flex justify-between px-5 w-full text-base cursor-pointer' onClick={() => setDisplayLanguage(!displayLanguage)}> 
                    <div>{languageSearch}</div> 
                    <ChevronDown className={`text-gray-400 transition-transform ${displayLanguage? 'rotate-180' : ''}`}/>
                </div>

                { displayLanguage && (
                    <ul id='languages ' className='absolute top-full left-0 w-full mt-2  py-3 rounded-md bg-white border border-gray-300 z-10 shadow-lg'>
                        
                        {LanguagesData.map((language) => (
                            <li className='px-5 py-2 hover:bg-[#8080801a] hover:cursor-pointer' onClick={()=> {setDisplayLanguage(false); setLanguageSearch(language)}}>{language}</li>
                        ))}
                    </ul>
                )}
                
            </div>

            <button
            type="submit"
            className='bg-[#6949fa] w-full md:w-[10%] h-10 rounded-md py-3 px-5 text-base font-bold text-white border border-[#6949fa] flex items-center justify-center hover:cursor-pointer hover:shadow-xl/20 transition duration-[.5s] ease-in-out'>
                SEARCH
            </button>
        </form>

        <section className='container px-4 py-10 mx-auto'>
            <div className='mb-8'>
                <div className='text-3xl font-bold mb-2 '> Featured Projects </div>
                <p className='text-gray-600 font-medium'> {repos.length} {repos.length === 1 ? "Project" : "Projects"}... </p>
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'> 
                
                 { repos.map((data) => (
                    <div className='bg-white border border-gray-300 rounded-xl px-6 py-6 pb-9 shadow-lg'>
                    <div className='flex flex-start justify-between items-start'>
                        <h4 className='text-xl font-bold'>{data.name}</h4>
                        
                    </div>
                    
                    <div className='text-sm text-[#65738a] font-medium py-2 mb-4 line-clamp-2 truncate '>{data.description} </div>
                    <div className='flex flex-start justify-between items-center'>
                        <div className='flex text-sm gap-4'>
                            <div className='flex items-center gap-1 text-[#65738a]'>
                                <Star className='h-4 w-4 '/>
                                <div className='font-bold'>{data.stargazers_count}</div>
                            </div>
                            <div className='flex items-center gap-1 text-[#65738a]'>
                                <GitFork className='h-4 w-4 '/>
                                <div className='font-bold'>{data.forks_count}</div>
                            </div>
                        </div>
                        
                    </div>

                    <div className='flex gap-2 text-sm py-3'>
                        {data.language != null ? <div className='border border-gray-300 text-xs font-bold rounded-3xl py-1 px-2'>  {data.language} </div>:
                         <div className='border border-[white] text-xs font-bold rounded-3xl py-1 px-2 pt-5'>  </div>}
                    
                        
                    </div>


                    <button className='w-full rounded-xl mt-4 hover:shadow-xl/20 transition ease-in-out' style={{background: "linear-gradient(135deg, hsl(250 95% 63%), hsl(270 90% 70%))"}}>
                           <a href={data.html_url} rel="noopener noreferrer" target="_blank" className='flex justify-center item-center gap-2 text-center text-white text-sm font-bold py-3 '>   
                                View Project
                                <ExternalLink size={18} />
                           </a>
                    </button>
                </div>
                ))}  
               
            </div>

            {hasmore && (
                <div className='flex justify-center mt-8 ' >
                    <div onClick={() => setPage((p) => p + 1)} className='border rounded-md py-3 px-8 hover:cursor-pointer hover:shadow-xl transition delay-1 ease-linear'>
                        {loading ? "Loading...": "Load More"}
                    </div>
                </div>
            )

            }
        </section>

        <Footer />
    </div>
  );
}

export default Projects;
